export default __webpack_public_path__ + "static/Image_Free_1-671f80617e7679add7ff093a1ca9c864.png";